<template>
  <div class="q-preloader-transport container">
    <img
      src="@/assets/images/preloader-transport.svg"
      v-for="(_, idx) in 8"
      :key="idx"
    >
  </div>
</template>

<style scoped lang="scss">
.q-preloader-transport{
  width: 1225px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  img{
    margin-bottom: 18px;
    animation-name: blink;
    animation-duration: .6s;
    animation-timing-function: ease-out;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-play-state: running;
  }
}

@keyframes blink {
  0% { opacity: .5; }
  100% { opacity: 1; }
}
</style>